import { render, staticRenderFns } from "./FeedsFieldFormGroup.vue?vue&type=template&id=d0efdef2"
import script from "./FeedsFieldFormGroup.vue?vue&type=script&lang=js"
export * from "./FeedsFieldFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports